import { GET_LEAVE_HISTORY_LIST } from "./types";
// !!!
export const getLeaveHistoryListRequest = (data: any) => {
  return {
    type: GET_LEAVE_HISTORY_LIST.GET_LEAVE_HISTORY_LIST_REQUEST,
    payload: { data },
  } as const;
};

export const getLeaveHistoryListSuccess = (data: any) => {
  return {
    type: GET_LEAVE_HISTORY_LIST.GET_LEAVE_HISTORY_LIST_SUCCESS,
    payload: { data },
  } as const;
};

export const getLeaveHistoryListFailed = () => {
  return {
    type: GET_LEAVE_HISTORY_LIST.GET_LEAVE_HISTORY_LIST_FAILED,
  } as const;
};

export type LeaveHistoryActions =
  | ReturnType<typeof getLeaveHistoryListRequest>
  | ReturnType<typeof getLeaveHistoryListSuccess>
  | ReturnType<typeof getLeaveHistoryListFailed>;
